import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const name = "errorLog";
const reducers = createReducers();
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

export const errorLogActions = { ...slice.actions, ...extraActions };
export const errorLogReducer = slice.reducer;

function createInitialState() {
  return {
    value: null,
  };
}

function createReducers() {
  return {};
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    logClientError: logClientError(),
  };

  function logClientError() {
    return createAsyncThunk(
      `${name}/logClientError`,
      async (request) => {
        try {
          const response = await fetch(`${baseUrl}/log-client-error`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Api-key': process.env.REACT_APP_API_SECURITY_TOKEN || '',
            },
            body: JSON.stringify(request),
            keepalive: true,
          });
          const isJson = response.headers?.get('content-type')?.includes('application/json');
          return isJson ? await response.json() : null;
        } catch (_) {
          return null;
        }
      }
    );
  }
}
